import "./css/form_field.css";

const FormField = ({
  input_type,
  name,
  icon_url,
  placeholder_text,
  full_size,
  roles,
  has_textarea,
  isDemo,
  isGetInTouch,
  setPayload,
  setPayloadGetInTouch,
  isValid
}) => {
  const common_style = {
    backgroundImage: `url(${icon_url})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto 18px",
    backgroundPosition: "12px 17px",
  };

  return (
    <div
      className={`form_field${full_size ? " full_size" : ""}${
        has_textarea ? " has_textarea" : ""
      }${!isValid ? " failed_form_validation" : ""}`}
    >
      {input_type === "select" && (
        <select
          name={name}
          id={name}
          className="form_input select"
          style={common_style}
          onChange={(e) => {
            const selected_option = e.target.selectedOptions[0].value;
            if (isDemo) {
              setPayload((prev) => ({ ...prev, role: selected_option }));
            }
            if (isGetInTouch) {
              setPayloadGetInTouch((prev) => ({
                ...prev,
                role: selected_option,
              }));
            }
          }}
        >
          <option>Your Role</option>
          {roles?.map((role, index) => (
            <option key={index} value={role}>
              {role.replace("_", " ")}
            </option>
          ))}
        </select>
      )}
      {input_type === "textarea" && (
        <textarea
          name={name}
          placeholder={placeholder_text}
          className="form_input textarea"
          style={common_style}
          onChange={(e) => {
            if (isGetInTouch) {
              setPayloadGetInTouch((prev) => ({
                ...prev,
                [name]: e.target.value,
              }));
            }
          }}
        ></textarea>
      )}
      {!(input_type === "select" || input_type === "textarea") && (
        <input
          type={input_type}
          name={name}
          id={name}
          placeholder={placeholder_text}
          className={`form_input${name === "email" ? " email" : ""}`}
          style={common_style}
          onChange={(e) => {
            if (isDemo) {
              setPayload((prev) => ({ ...prev, [name]: e.target.value }));
            }
            if (isGetInTouch) {
              setPayloadGetInTouch((prev) => ({
                ...prev,
                [name]: e.target.value,
              }));
            }
          }}
        />
      )}
    </div>
  );
};

export default FormField;
